import { render } from "./CustomerDetailInformationTab.vue?vue&type=template&id=1289ea42"
import script from "./CustomerDetailInformationTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailInformationTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__